// import React from 'react';
// import moment from 'moment';

// const GeoExplorerTemplate = ({ packageData, user }) => {
//     if (!packageData?.package) return <div>Loading...</div>;
//     const { package: pkg } = packageData;
//     const accentColor = '#F6AD55'; // A vibrant amber/gold
//     const primaryTextColor = '#E2E8F0';
//     const secondaryTextColor = '#A0AEC0';
//     const backgroundColor = '#1A202C'; // A very dark blue/charcoal

//     // Faint world map background image
//     const mapBackground = 'https://subtlepatterns.com/patterns/world_map_vector.png';

//     return (
//         <div style={{ fontFamily: "'Montserrat', sans-serif", backgroundColor, color: primaryTextColor }}>
//             <style>
//                 {`@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');`}
//             </style>

//             {/* Hero Section */}
//             <header style={{
//                 backgroundImage: `linear-gradient(rgba(26, 44, 64, 0.7), rgba(26, 44, 64, 0.7)), url(${pkg.imageSrc})`,
//                 backgroundSize: 'cover',
//                 backgroundPosition: 'center',
//                 padding: '60px 30px',
//                 textAlign: 'center'
//             }}>
//                 <h1 style={{ fontSize: '48px', fontWeight: '700', color: 'white', margin: 0 }}>{pkg.packageName}</h1>
//                 <p style={{ fontSize: '20px', color: accentColor, marginTop: '10px', letterSpacing: '1px' }}>{pkg.destinationsCover}</p>
//             </header>
            
//             {/* Stats Bar */}
//             <div style={{ display: 'flex', justifyContent: 'space-around', backgroundColor: '#2D3748', padding: '20px', textAlign: 'center' }}>
//                 <div>
//                     <div style={{ fontSize: '14px', color: secondaryTextColor }}>DURATION</div>
//                     <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{pkg.duration}</div>
//                 </div>
//                 <div>
//                     <div style={{ fontSize: '14px', color: secondaryTextColor }}>START DATE</div>
//                     <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{moment(pkg.startedDate).format("DD MMM YYYY")}</div>
//                 </div>
//                 <div>
//                     <div style={{ fontSize: '14px', color: secondaryTextColor }}>PRICE (per person)</div>
//                     <div style={{ fontSize: '20px', fontWeight: 'bold', color: accentColor }}>{pkg.price} {pkg.currency}</div>
//                 </div>
//             </div>

//             {/* Main Content with Map Background */}
//             <main style={{
//                 padding: '40px 30px',
//                 backgroundImage: `url(${mapBackground})`,
//                 backgroundRepeat: 'no-repeat',
//                 backgroundPosition: 'center center',
//                 backgroundColor: 'rgba(26, 32, 44, 0.95)', // Dark overlay to ensure readability
//                 backgroundBlendMode: 'overlay',
//             }}>
//                 {/* Overview */}
//                 <section style={{ marginBottom: '40px' }}>
//                     <h2 style={{ fontSize: '24px', fontWeight: 'bold', borderBottom: `2px solid ${accentColor}`, paddingBottom: '10px', marginBottom: '20px' }}>Your Adventure Awaits</h2>
//                     <p style={{ fontSize: '16px', lineHeight: '1.7', color: secondaryTextColor }}>{pkg.description}</p>
//                 </section>

//                 {/* Itinerary */}
//                 {packageData.itineraries?.length > 0 && (
//                     <section style={{ marginBottom: '40px' }}>
//                         <h2 style={{ fontSize: '24px', fontWeight: 'bold', borderBottom: `2px solid ${accentColor}`, paddingBottom: '10px', marginBottom: '20px' }}>Expedition Itinerary</h2>
//                         {packageData.itineraries.slice().sort((a, b) => new Date(a.date) - new Date(b.date)).map((item, index) => (
//                             <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '25px' }}>
//                                 <div style={{ marginRight: '20px', textAlign: 'center' }}>
//                                     <div style={{ backgroundColor: accentColor, color: backgroundColor, borderRadius: '50%', width: '40px', height: '40px', lineHeight: '40px', fontWeight: 'bold', fontSize: '18px' }}>{index + 1}</div>
//                                 </div>
//                                 <div style={{ backgroundColor: '#2D3748', padding: '15px', borderRadius: '8px', flex: 1 }}>
//                                     <h4 style={{ margin: 0, fontSize: '18px', color: primaryTextColor }}>{item.title} - <span style={{ color: secondaryTextColor, fontWeight: 'normal' }}>{moment(item.date).format("MMMM Do")}</span></h4>
//                                     <p style={{ margin: '10px 0 0', color: secondaryTextColor }}>{item.description}</p>
//                                 </div>
//                             </div>
//                         ))}
//                     </section>
//                 )}
                
//                 {/* Includes & Excludes */}
//                 <section style={{ display: 'flex', gap: '30px' }}>
//                     {packageData.includes?.length > 0 && (
//                         <div style={{ flex: 1, backgroundColor: '#2D3748', padding: '20px', borderRadius: '8px' }}>
//                             <h3 style={{ color: '#48BB78', fontSize: '18px' }}>WHAT'S INCLUDED</h3>
//                             <ul style={{ paddingLeft: '20px', color: secondaryTextColor }}>
//                                 {packageData.includes.map((item, i) => <li key={i} style={{ marginBottom: '8px' }}>{item.description}</li>)}
//                             </ul>
//                         </div>
//                     )}
//                     {packageData.excludes?.length > 0 && (
//                         <div style={{ flex: 1, backgroundColor: '#2D3748', padding: '20px', borderRadius: '8px' }}>
//                              <h3 style={{ color: '#F56565', fontSize: '18px' }}>WHAT'S EXCLUDED</h3>
//                              <ul style={{ paddingLeft: '20px', color: secondaryTextColor }}>
//                                 {packageData.excludes.map((item, i) => <li key={i} style={{ marginBottom: '8px' }}>{item.description}</li>)}
//                             </ul>
//                         </div>
//                     )}
//                 </section>
//             </main>
            
//             {/* Footer */}
//             <footer style={{ padding: '20px', textAlign: 'center', backgroundColor: '#2D3748', fontSize: '14px' }}>
//                 <p>Quotation prepared by {user?.companyName || 'our team'}. Contact: {pkg.contactEmail}</p>
//             </footer>
//         </div>
//     );
// };

// export default GeoExplorerTemplate;

import React from 'react';
import moment from 'moment';

const GeoExplorerTemplate = ({ packageData, user }) => {
    if (!packageData?.package) return <div>Loading...</div>;
    const { package: pkg } = packageData;

    // --- Style Palette ---
    const accentColor = '#F6AD55'; // A vibrant amber/gold
    const primaryTextColor = '#E2E8F0';
    const secondaryTextColor = '#A0AEC0';
    const backgroundColor = '#1A202C'; // A very dark blue/charcoal
    const blockBackgroundColor = '#2D3748'; // Darker grey for content blocks

    // Faint world map background image
    const mapBackground = 'https://subtlepatterns.com/patterns/world_map_vector.png';
    
    // --- Helper for Section Titles ---
    const SectionTitle = ({ children }) => (
      <h2 style={{ fontSize: '24px', fontWeight: 'bold', borderBottom: `2px solid ${accentColor}`, paddingBottom: '10px', marginBottom: '20px', color: primaryTextColor }}>
        {children}
      </h2>
    );

    return (
        <div style={{ fontFamily: "'Montserrat', sans-serif", backgroundColor, color: primaryTextColor }}>
            {/* <style>
                {`@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');`}
            </style> */}

            {/* Hero Section */}
            <header style={{
                backgroundImage: `linear-gradient(rgba(26, 32, 44, 0.7), rgba(26, 32, 44, 0.7)), url(${pkg.imageSrc})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '60px 30px',
                textAlign: 'center'
            }}>
                <h1 style={{ fontSize: '48px', fontWeight: '700', color: 'white', margin: 0 }}>{pkg.packageName}</h1>
                <p style={{ fontSize: '20px', color: accentColor, marginTop: '10px', letterSpacing: '1px' }}>{pkg.destinationsCover}</p>
            </header>
            
            {/* Stats Bar */}
            <div style={{ display: 'flex', justifyContent: 'space-around', backgroundColor: blockBackgroundColor, padding: '20px', textAlign: 'center' }}>
                <div>
                    <div style={{ fontSize: '14px', color: secondaryTextColor, textTransform: 'uppercase' }}>Duration</div>
                    <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{pkg.duration}</div>
                </div>
                <div>
                    <div style={{ fontSize: '14px', color: secondaryTextColor, textTransform: 'uppercase' }}>Start Date</div>
                    <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{moment(pkg.startedDate).format("DD MMM YYYY")}</div>
                </div>
                <div>
                    <div style={{ fontSize: '14px', color: secondaryTextColor, textTransform: 'uppercase' }}>Price</div>
                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: accentColor }}>{pkg.price} {pkg.currency}</div>
                </div>
            </div>

            {/* Main Content with Map Background */}
            <main style={{
                padding: '40px 30px',
                backgroundImage: `url(${mapBackground})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundColor: 'rgba(26, 32, 44, 0.95)', // Dark overlay to ensure readability
                backgroundBlendMode: 'overlay',
            }}>
                {/* Overview */}
                <section style={{ marginBottom: '40px' }}>
                    <SectionTitle>Your Adventure Awaits</SectionTitle>
                    <p style={{ fontSize: '16px', lineHeight: '1.7', color: secondaryTextColor }}>{pkg.description}</p>
                </section>

                {/* Itinerary */}
                {packageData.itineraries?.length > 0 && (
                    <section style={{ marginBottom: '40px' }}>
                        <SectionTitle>Expedition Itinerary</SectionTitle>
                        {packageData.itineraries.slice().sort((a, b) => new Date(a.date) - new Date(b.date)).map((item, index) => (
                            <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '25px' }}>
                                <div style={{ marginRight: '20px', textAlign: 'center' }}>
                                    <div style={{ backgroundColor: accentColor, color: backgroundColor, borderRadius: '50%', width: '40px', height: '40px', lineHeight: '40px', fontWeight: 'bold', fontSize: '18px' }}>{index + 1}</div>
                                </div>
                                <div style={{ backgroundColor: blockBackgroundColor, padding: '15px 20px', borderRadius: '8px', flex: 1 }}>
                                    <h4 style={{ margin: 0, fontSize: '18px', color: primaryTextColor }}>{item.title} - <span style={{ color: secondaryTextColor, fontWeight: 'normal' }}>{moment(item.date).format("MMMM Do")}</span></h4>
                                    <p style={{ margin: '10px 0 0', color: secondaryTextColor }}>{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </section>
                )}

                {/* --- FLIGHT DETAILS --- */}
                {packageData.flightBookings?.length > 0 && (
                    <section style={{ marginBottom: '40px' }}>
                        <SectionTitle>Flight Logistics</SectionTitle>
                        {packageData.flightBookings.map((flight, index) => (
                            <div key={index} style={{ backgroundColor: blockBackgroundColor, padding: '20px', borderRadius: '8px', marginBottom: '15px' }}>
                                <h4 style={{ margin: 0, color: accentColor, fontWeight: 'bold' }}>{flight.airline} - {flight.flightNumber}</h4>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px' }}>
                                    <div>
                                        <div style={{ color: secondaryTextColor, fontSize: '14px' }}>DEPARTURE</div>
                                        <div style={{ fontSize: '16px' }}>{flight.departureCity}</div>
                                        <div style={{ fontSize: '16px' }}>{moment(flight.departureDateTime).format("DD MMM YYYY, h:mm a")}</div>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <div style={{ color: secondaryTextColor, fontSize: '14px' }}>ARRIVAL</div>
                                        <div style={{ fontSize: '16px' }}>{flight.arrivalCity}</div>
                                        <div style={{ fontSize: '16px' }}>{moment(flight.arrivalDateTime).format("DD MMM YYYY, h:mm a")}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </section>
                )}

                {/* --- ACCOMMODATIONS --- */}
                {packageData.hotelBookings?.length > 0 && (
                    <section style={{ marginBottom: '40px' }}>
                        <SectionTitle>Basecamp Accommodations</SectionTitle>
                         <div style={{ backgroundColor: blockBackgroundColor, padding: '20px', borderRadius: '8px' }}>
                            {packageData.hotelBookings.map((hotel, index) => (
                                <div key={index} style={{ padding: '15px 0', borderBottom: index === packageData.hotelBookings.length - 1 ? 'none' : `1px solid ${backgroundColor}` }}>
                                    <h4 style={{ margin: 0, color: primaryTextColor }}>{hotel.hotelName}</h4>
                                    <p style={{ margin: '5px 0 0', color: secondaryTextColor }}>{hotel.city} | {moment(hotel.checkInDate).format("DD MMM")} - {moment(hotel.checkOutDate).format("DD MMM YYYY")}</p>
                                </div>
                            ))}
                         </div>
                    </section>
                )}

                {/* --- SIGHTSEEING & TRANSFERS --- */}
                {(packageData.sightSeeings?.length > 0 || packageData.transfers?.length > 0) && (
                    <section style={{ marginBottom: '40px' }}>
                        <SectionTitle>Key Activities & Transfers</SectionTitle>
                        <div style={{ backgroundColor: blockBackgroundColor, padding: '20px', borderRadius: '8px' }}>
                            {packageData.sightSeeings?.length > 0 && (
                                <div style={{ marginBottom: '20px' }}>
                                    <h4 style={{ color: accentColor, marginBottom: '10px' }}>SIGHTSEEING</h4>
                                    <ul style={{ paddingLeft: '20px', margin: 0, color: secondaryTextColor }}>
                                        {packageData.sightSeeings.map((sight, i) => <li key={i} style={{ marginBottom: '5px' }}>{moment(sight.date).format("DD MMM")}: {sight.sightseeingName} in {sight.destination}</li>)}
                                    </ul>
                                </div>
                            )}
                            {packageData.transfers?.length > 0 && (
                                <div>
                                    <h4 style={{ color: accentColor, marginBottom: '10px' }}>TRANSFERS</h4>
                                     <ul style={{ paddingLeft: '20px', margin: 0, color: secondaryTextColor }}>
                                        {packageData.transfers.map((transfer, i) => <li key={i} style={{ marginBottom: '5px' }}>{moment(transfer.date).format("DD MMM")} at {transfer.pickupTime}: {transfer.fromLocation} to {transfer.toLocation}</li>)}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </section>
                )}

                {/* --- INCLUDES & EXCLUDES --- */}
                <section style={{ display: 'flex', gap: '30px', marginBottom: '40px' }}>
                    {packageData.includes?.length > 0 && (
                        <div style={{ flex: 1, backgroundColor: blockBackgroundColor, padding: '20px', borderRadius: '8px' }}>
                            <h3 style={{ color: '#48BB78', fontSize: '18px', textTransform: 'uppercase' }}>What's Included</h3>
                            <ul style={{ paddingLeft: '20px', color: secondaryTextColor, marginTop: '15px' }}>
                                {packageData.includes.map((item, i) => <li key={i} style={{ marginBottom: '8px' }}>{item.description}</li>)}
                            </ul>
                        </div>
                    )}
                    {packageData.excludes?.length > 0 && (
                        <div style={{ flex: 1, backgroundColor: blockBackgroundColor, padding: '20px', borderRadius: '8px' }}>
                             <h3 style={{ color: '#F56565', fontSize: '18px', textTransform: 'uppercase' }}>What's Excluded</h3>
                             <ul style={{ paddingLeft: '20px', color: secondaryTextColor, marginTop: '15px' }}>
                                {packageData.excludes.map((item, i) => <li key={i} style={{ marginBottom: '8px' }}>{item.description}</li>)}
                            </ul>
                        </div>
                    )}
                </section>

                {/* --- TERMS & CONDITIONS --- */}
                {packageData.termsandConditions?.length > 0 && (
                    <section>
                        <SectionTitle>Terms & Conditions</SectionTitle>
                        {packageData.termsandConditions.map((term, index) => (
                            <div key={index} style={{ marginBottom: '15px' }}>
                                <h4 style={{ color: accentColor, fontSize: '16px' }}>{term.title}</h4>
                                <p style={{ color: secondaryTextColor, lineHeight: '1.6' }}>{term.description}</p>
                            </div>
                        ))}
                    </section>
                )}
            </main>
            
            {/* Footer */}
            <footer style={{ padding: '20px', textAlign: 'center', backgroundColor: blockBackgroundColor, fontSize: '14px' }}>
                <p style={{ margin: 0, color: secondaryTextColor }}>Quotation prepared by {user?.companyName || 'our team'}. Contact: {pkg.contactEmail}</p>
            </footer>
        </div>
    );
};

export default GeoExplorerTemplate;